import container from './CQRS';

const { queriesController, commandsController } = container;

async function getTaskPriorities() {
  try {
    return await queriesController.fetchTaskPriorities();
  } catch (error) {
    throw new Error('[Service]: Oops!, we were unable to obtain the task priorities...');
  }
}

async function getAllTasks(childId, filter_task = {}) {
  const filter = `?${new URLSearchParams(filter_task).toString()}`;
  try {
    return await queriesController.fetchAllChildTasks({ childId, filter });
  } catch (error) {
    throw new Error("[Service]: Oops!, Unable to obtain child's all tasks.");
  }
}

async function getAllProjects(childId) {
  try {
    return await queriesController.fetchProjects({ childId });
  } catch (error) {
    throw new Error("[Service]: Oops!, Unable to obtain child's all projects.");
  }
}

async function setNewProject(childId, newProject) {
  const due_date = `${newProject.due_date}T${newProject.due_hour}`;

  const newProjectBody = { ...newProject, due_date, child: childId };

  try {
    return await commandsController.addNewProject({ newProjectBody });
  } catch (error) {
    throw new Error('[Service]: Oops!, I could not save a new project.');
  }
}

async function getProjectInfo(projectId) {
  try {
    return await queriesController.fetchProjectInfo({ projectId });
  } catch (error) {
    throw new Error('[Service]: Oops!, Unable to obtain project info.');
  }
}
async function editProject(projectId, childId, editProjectData) {
  const due_date = `${editProjectData.due_date}T${editProjectData.due_hour}`;

  const editProjectBody = { ...editProjectData, due_date, child: childId };

  try {
    return await commandsController.editProject({ projectId, editProjectBody });
  } catch (error) {
    throw new Error('[Service]: Oops!, I could not edit the project.');
  }
}
async function deleteProject(projectId, childId) {
  try {
    return await commandsController.deleteProject({ projectId, child: childId });
  } catch (error) {
    throw new Error('[Service]: Oops!, I could not delete the project.');
  }
}
async function updateTimeInATask(state, tasksId) {
  try {
    return await commandsController.updateTimeInATask({ state, tasksId });
  } catch (error) {
    throw new Error('[Service]: Oops!, I have not been able to update the task timer.');
  }
}

async function getTaskInfo(taskId) {
  try {
    return await queriesController.fetchTaskInfo({ taskId });
  } catch (error) {
    throw new Error('[Service]: Oops!, Unable to obtain task info.');
  }
}

async function getTaskTypes() {
  try {
    return await queriesController.fetchTaskTypes();
  } catch (error) {
    throw new Error('[Service]: Oops!, Unable to obtain task types.');
  }
}

async function getTaskRepeatOptions() {
  try {
    return await queriesController.fetchTaskRepeatOptions();
  } catch (error) {
    throw new Error('[Service]: Oops!, Unable to obtain task repeat options.');
  }
}

async function getTaskTypesNotifications() {
  try {
    return await queriesController.fetchTaskTypesNotifications();
  } catch (error) {
    throw new Error('[Service]: Oops!, Unable to obtain types notifications for tasks.');
  }
}

async function setNewTask(taskData) {
  try {
    return commandsController.createTask({ taskData });
  } catch (error) {
    throw new Error('[Service]: Oops!, we were unable to create the task');
  }
}

async function setEditTask(taskId, taskData) {
  try {
    return commandsController.editTask({ taskId, taskData });
  } catch (error) {
    throw new Error('[Service]: Oops!, we were unable to update the task');
  }
}

async function deleteTask(taskId) {
  try {
    return commandsController.deleteTask({ taskId });
  } catch (error) {
    throw new Error('[Service]: Oops!, we were unable to delete the task');
  }
}

async function setTaskStatus(taskId, status) {
  try {
    return commandsController.updateTaskStatus({ taskId, status });
  } catch (error) {
    throw new Error('[Service]: Oops!, we were unable to update the task status');
  }
}

async function getCalendar(childId, query = {}) {
  const queryParams = `?${new URLSearchParams(query).toString()}`;
  try {
    return await queriesController.fetchCalendar({ childId, queryParams });
  } catch (error) {
    throw new Error('[Service]: Oops!, Unable to obtain calendar.');
  }
}

async function getAllTaskTimers() {
  try {
    return await queriesController.fetchAllTaskTimers();
  } catch (error) {
    throw new Error('[Service]: Oops!, Unable to obtain task timer.');
  }
}

export {
  getAllTasks,
  getAllProjects,
  setNewProject,
  getTaskInfo,
  getTaskTypes,
  getTaskRepeatOptions,
  getTaskTypesNotifications,
  setNewTask,
  setEditTask,
  getTaskPriorities,
  getProjectInfo,
  editProject,
  deleteProject,
  deleteTask,
  updateTimeInATask,
  setTaskStatus,
  getCalendar,
  getAllTaskTimers,
};
